import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

const SearchGroupContext = createContext<[boolean, Dispatch<SetStateAction<boolean>>]>([
  false,
  () => ({}),
]);

const Provider = (props: { children: ReactNode }) => {
  const [isVisible, setIsVisible] = useState(false);
  const value = useMemo<[boolean, Dispatch<SetStateAction<boolean>>]>(
    () => [isVisible, setIsVisible],
    [isVisible],
  );
  return <SearchGroupContext.Provider value={value} {...props} />;
};

function useToggle() {
  const context = useContext(SearchGroupContext);
  if (!context) {
    throw new Error(`useToggle must be used within a Search Group Provider`);
  }
  const [isVisible, setIsVisible] = context;
  const onToggle = (val: boolean) => setIsVisible(val);

  return {
    isVisible,
    setIsVisible,
    onToggle,
  };
}

export default { Provider, useToggle };
